export default "__VITE_ASSET__661a1ecf__"